const IndianStates = [
  { code: 'AN', name: 'Andaman and Nicobar Islands' },
  { code: 'AP', name: 'Andhra Pradesh' },
  { code: 'AR', name: 'Arunachal Pradesh' },
  { code: 'AS', name: 'Assam' },
  { code: 'BR', name: 'Bihar' },
  { code: 'CG', name: 'Chandigarh' },
  { code: 'CH', name: 'Chattisgarh' },
  { code: 'DH', name: 'Dadra and Nagar Haveli' },
  { code: 'DD', name: 'Daman and Diu' },
  { code: 'DL', name: 'Delhi' },
  { code: 'GA', name: 'Goa' },
  { code: 'GJ', name: 'Gujarat' },
  { code: 'HR', name: 'Haryana' },
  { code: 'HP', name: 'Himachal Pradesh' },
  { code: 'JK', name: 'Jammu and Kashmir' },
  { code: 'JH', name: 'Jharkhand' },
  { code: 'KA', name: 'Karnataka' },
  { code: 'KL', name: 'Kerala' },
  { code: 'LD', name: 'Lakshadweep' },
  { code: 'MP', name: 'Madhya Pradesh' },
  { code: 'MH', name: 'Maharashtra' },
  { code: 'MN', name: 'Manipur' },
  { code: 'ML', name: 'Meghalaya' },
  { code: 'MZ', name: 'Mizoram' },
  { code: 'NL', name: 'Nagaland' },
  { code: 'OR', name: 'Odisha' },
  { code: 'PY', name: 'Puducherry' },
  { code: 'PB', name: 'Punjab' },
  { code: 'RJ', name: 'Rajasthan' },
  { code: 'SK', name: 'Sikkim' },
  { code: 'TN', name: 'Tamil Nadu' },
  { code: 'TS', name: 'Telangana' },
  { code: 'TR', name: 'Tripura' },
  { code: 'UK', name: 'Uttarakhand' },
  { code: 'UP', name: 'Uttar Pradesh' },
  { code: 'WB', name: 'West Bengal' }
];

const stateRegionMapping = [
  { name: 'Andhra Pradesh', region: 'South 1' },
  { name: 'Assam', region: 'NE 1' },
  { name: 'Arunachal Pradesh', region: 'NE 3' },
  { name: 'Bihar', region: 'East 2' },
  { name: 'Chandigarh', region: 'North 2' },
  { name: 'Chattisgarh', region: 'Central 2' },
  { name: 'Delhi', region: 'NCR' },
  { name: 'Daman and Diu', region: 'Union Territory' },
  { name: 'Dadra and Nagar Haveli', region: 'Union Territory' },
  { name: 'Gujarat', region: 'West 1' },
  { name: 'Haryana', region: 'North 2' },
  { name: 'Himachal Pradesh', region: 'North 1' },
  { name: 'Goa', region: 'West 2' },
  { name: 'Jammu and Kashmir', region: 'J&K' },
  { name: 'Jharkhand', region: 'East 1' },
  { name: 'Karnataka', region: 'South 2' },
  { name: 'Kerala', region: 'South 2' },
  { name: 'Madhya Pradesh', region: 'Central 2' },
  { name: 'Maharashtra', region: 'West 2' },
  { name: 'Manipur', region: 'NE 2' },
  { name: 'Meghalaya', region: 'NE 1' },
  { name: 'Mizoram', region: 'NE 2' },
  { name: 'Nagaland', region: 'NE 2' },
  { name: 'Odisha', region: 'East 1' },
  { name: 'Punjab', region: 'North 2' },
  { name: 'Puducherry', region: 'Union Territory' },
  { name: 'Telangana', region: 'Central 1' },
  { name: 'Tripura', region: 'NE 1' },
  { name: 'Rajasthan', region: 'North 3' },
  { name: 'Tamil Nadu', region: 'South 2' },
  { name: 'Sikkim', region: 'East 2' },
  { name: 'Uttar Pradesh', region: 'West UP' },
  { name: 'Uttarakhand', region: 'North 1' },
  { name: 'West Bengal', region: 'East 1' },
];

const stateCodes = [
  { code: '01', name: 'JAMMU AND KASHMIR' },
  { code: '02', name: 'HIMACHAL PRADESH' },
  { code: '03', name: 'PUNJAB' },
  { code: '04', name: 'CHANDIGARH' },
  { code: '05', name: 'UTTARAKHAND' },
  { code: '06', name: 'HARYANA' },
  { code: '07', name: 'DELHI' },
  { code: '08', name: 'RAJASTHAN' },
  { code: '09', name: 'UTTAR PRADESH' },
  { code: '10', name: 'BIHAR' },
  { code: '11', name: 'SIKKIM' },
  { code: '12', name: 'ARUNACHAL PRADESH' },
  { code: '13', name: 'NAGALAND' },
  { code: '14', name: 'MANIPUR' },
  { code: '15', name: 'MIZORAM' },
  { code: '16', name: 'TRIPURA' },
  { code: '17', name: 'MEGHALAYA' },
  { code: '18', name: 'ASSAM' },
  { code: '19', name: 'WEST BENGAL' },
  { code: '20', name: 'JHARKHAND' },
  { code: '21', name: 'ODISHA' },
  { code: '22', name: 'CHATTISGARH' },
  { code: '23', name: 'MADHYA PRADESH' },
  { code: '24', name: 'GUJARAT' },
  { code: '26', name: 'DAMAN AND DIU' },
  { code: '26', name: 'DADRA AND NAGAR HAVELI' },
  { code: '27', name: 'MAHARASHTRA' },
  { code: '28', name: 'ANDHRA PRADESH' },
  { code: '29', name: 'KARNATAKA' },
  { code: '30', name: 'GOA' },
  { code: '31', name: 'LAKSHADWEEP' },
  { code: '32', name: 'KERALA' },
  { code: '33', name: 'TAMIL NADU' },
  { code: '34', name: 'PUDUCHERRY' },
  { code: '35', name: 'ANDAMAN AND NICOBAR ISLANDS' },
  { code: '36', name: 'TELANGANA' },
  { code: '37', name: 'ANDHRA PRADESH' },
  { code: '38', name: 'LADAKH' },
];

const stateRegionMap = stateRegionMapping.reduce((acc, item) => {
  acc[item.name] = item.region;
  return acc;
}, {});

module.exports = {
  IndianStates,
  stateRegionMapping,
  stateRegionMap,
  stateCodes,
};
